import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, TagsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof TagsResponseDataSchema>>

export const getTagsQueryKey = () => ["customerTags"]

export const tagsQuery = () => {
  return queryOptions({
    queryKey: getTagsQueryKey(),
    queryFn: async () => {
      const response = await axios.get<Response>("/customers/tags")

      return response.data.data
    },
    staleTime: 1000 * 60 * 2,
  })
}
